export default "/images/box-arrow-in-right.svg?369ce75a3ace90c23d2eaa337a2bd491";